import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import View from './view';
import WebMercatorViewport from '../viewports/web-mercator-viewport';
import MapController from '../controllers/map-controller';
export default class MapView extends View {
  get ViewportType() {
    return WebMercatorViewport;
  }

  get ControllerType() {
    return MapController;
  }

}

_defineProperty(MapView, "displayName", 'MapView');
//# sourceMappingURL=map-view.js.map